import { spawn } from 'redux-saga/effects';
import authMiddleware from '@store/auth/auth-middleware';
import homeMiddleware from '@store/home-screen/home-middleware';
import labMiddleware from './lab/lab-middleware';
import appointmentMiddleware from './appointment/appointment-middleware';
import financialsMiddleware from './financials/financials-middleware';
import consultsMiddleware from './consults/consults-middleware';
import clientOrdersMiddleware from './client/orders/orders-middleware';
import usersMiddleware from './users/users-middleware';
import contactInformationMiddleware from './client/contact-information/contact-information-middleware';
import blogsMiddleware from './blogs/blog-middleware';
import homeCareMiddleware from './home-care/home-care-middleware';
import walletMiddleware from './client/wallet/wallet-middleware';
import pharmacyMiddleware from './pharmacies/pharmacies-middleware';
import basketMiddleware from './basket/basket-middleware';
import productsMiddleware from './products/products-middleware';
import messagesMiddleware from './client/messages/messages-middleware';
import clientComplaintsMiddleware from './client/complaints/complaints-middleware';
import commentsMiddleware from './client/comments/comments-middleware';

export default function* rootSaga() {
  yield spawn(authMiddleware);
  yield spawn(homeMiddleware);
  yield spawn(labMiddleware);
  yield spawn(consultsMiddleware);
  yield spawn(appointmentMiddleware);
  yield spawn(financialsMiddleware);
  yield spawn(clientOrdersMiddleware);
  yield spawn(contactInformationMiddleware);
  yield spawn(usersMiddleware);
  yield spawn(blogsMiddleware);
  yield spawn(homeCareMiddleware);
  yield spawn(walletMiddleware);
  yield spawn(pharmacyMiddleware);
  yield spawn(basketMiddleware);
  yield spawn(productsMiddleware);
  yield spawn(messagesMiddleware);
  yield spawn(clientComplaintsMiddleware);
  yield spawn(commentsMiddleware);
}
